import React, { useEffect, useState, forwardRef, useCallback, useContext, useRef } from 'react';
import { HomePageService } from '../services/homepage-service';
import { useParams } from "react-router-dom";
//import { useLocation } from "react-router-dom";
//import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HintError from '../components/hint-error';
import Loading from "../components/layouts/loading";
import WidgetDataRow from '../components/widgets/widget-data-row';
import { useFormik } from 'formik';

//copy-to-clipboard
import useCopy from "use-copy";

//import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';

import TitleGrows from "../components/title-grows";
//Snackbar, Menu
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import ListSubheader from '@mui/material/ListSubheader';
import TextField from '@mui/material/TextField';
//eslint-disable-next-line
// import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import LivetagAutocomplete from '../components/livetag-autocomplete';
import Countdown from '../components/widgets/countdown';
import MultipleLinkChips from '../components/widgets/multiple-link-chips';
import CategoryHeader from '../components/widgets/category-header';
import VerticalHeader from '../components/widgets/vertical-header';
import IndexHeader from '../components/widgets/index-header';
import RubricHeader from '../components/widgets/rubric-header';
import SingleLive from '../components/widgets/single-live';
import SingleArticle from '../components/widgets/single-article';
import MultiArticlesFilter from '../components/widgets/multi-articles-filter';
import MultiArticlesSelectedManually from '../components/widgets/multi-articles-selected-manually';
import MultipleSelectedArticles from '../components/widgets/multiple-selected-articles';
import CustomPagination from '../components/widgets/custom-pagination';
import CustomEditor from '../components/widgets/custom-editor';
import SelectMapList from '../components/widgets/map-regions/select-map-list';
import SelectAdvBannerList from '../components/widgets/select-adv-banner-list.jsx';

import FooterFixedBottom from '../components/footer-fixed-bottom';

//DND
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import styled from "styled-components";

import { makeStyles } from '@mui/styles';
import ShowPreview from '../components/show-preview';

import AuthContext from '../context/auth-context'
import * as userpermission from "../utils/PermissionCheck.js"

const useStyles = makeStyles({
  listSubheaderGroup: {
    padding: "0 8px !important",
    backgroundImage: "linear-gradient(45deg, #0a53be 40%, #0D6EFD 80%)",
    lineHeight: "20px !important",
    fontWeight: "800 !important",
    color: "white !important"
  },
});

const allOriginDomain = [
  "None",
  "All_domain",
  "www",
  "impact",
  "cybersecurity",
  "ischool",
  "openinnovation",
  "smartworking",
  "smartmoney",
  "sportup",
  "thefoodmakers",
  "thenexttech",
  "valoreresponsabile",
  "life",
];

const DragItem = styled.div`
  //padding: 0 20px 0 0;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background: white;
  margin: 0 0 6px 0;
  flex-direction: row;
  min-height: 64px;
`;

const REACT_APP_SI_DOMAIN = process.env.REACT_APP_SI_DOMAIN;

export default function HomePage() {

  const bottomTableRef = useRef();

  const authCtx = useContext(AuthContext);

  const [text, setText] = useState('');
  const [copied, copy, setCopied] = useCopy(text);
  const copyText = () => {
    setCopied(true);
    setTimeout(() => {
      copy();
      setCopied(false);
    }, 500);
  };

  const classesS = useStyles();

  //const location = useLocation();
  const { uri } = useParams();
  const maxWidgets = 50;

  const arrWidgetType = [
    { groupName: 'Headers', widgetsNames: ['CategoryHeader', 'VerticalHeader', 'IndexHeader', 'RubricHeader'] },
    { groupName: 'Lives / Videos', widgetsNames: ['LiveSlider', 'LiveSliderLatest', 'LiveGrid', 'SingleLive', 'SearchLiveBar'] },
    {
      groupName: 'Articles', widgetsNames: [
        'SingleHugeArticle',
        'SingleBigArticle',
        'SingleMediumArticle',
        'MultipleArticles',
        'MultipleSelectedArticles',
        'MultipleSelectedArticlesSlider',
        'TrendingTopics',
        'TrendingTopicsMultipleSelectedArticles',
        'MapWidgetRegions'
      ]
    },
    {
      groupName: 'Others', widgetsNames: [
        'Countdown',
        'MultipleLinkChips',
        'SocialMediaButtons',
        'EventSlider',
        'AnnouncementSlider',
        'CustomEditor'
      ]
    },
    { groupName: 'Utils', widgetsNames: ['CustomPagination', 'AdvBanner', 'Banners'] }
  ]

  const [homepageList, setHomepageList] = useState([]);
  const [widgets, setWidgets] = useState([]);
  const [errors, setErrors] = useState([]);
  const widgetType = '';
  const [isLoading, setIsLoading] = useState(false);
  const [showCountdown, setShowCountdown] = useState(false);
  const [showMultipleLinkChips, setShowMultipleLinkChips] = useState(false);
  const [showIndexHeader, setShowIndexHeader] = useState(false);
  const [showCategoryHeader, setShowCategoryHeader] = useState(false);
  const [showVerticalHeader, setShowVerticalHeader] = useState(false);
  const [showRubricHeader, setShowRubricHeader] = useState(false);
  const [showSingleLive, setShowSingleLive] = useState(false);
  const [showSingleHugeArticle, setShowSingleHugeArticle] = useState(false);
  const [showSingleBigArticle, setShowSingleBigArticle] = useState(false);
  const [showSingleMediumArticle, setShowSingleMediumArticle] = useState(false);
  const [showMultipleArticles, setShowMultipleArticles] = useState(false);
  const [showMultipleSelectedArticles, setShowMultipleSelectedArticles] = useState(false);
  const [showMultipleSelectedArticlesSlider, setShowMultipleSelectedArticlesSlider] = useState(false);
  const [showTrendingTopics, setShowTrendingTopics] = useState(false);
  const [showTrendingTopicsMultipleSelectedArticles, setShowTrendingTopicsMultipleSelectedArticles] = useState(false);
  const [showCustomPagination, setShowCustomPagination] = useState(false);
  const [showCustomEditor, setShowCustomEditor] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [widgetIndex, setWidgetIndex] = useState(-1);
  const [widgetSettingsOk, setWidgetSettingsOk] = useState(true);
  const [widgetsStateModified, setWidgetsStateModified] = useState(false);

  //Formik
  const formik = useFormik({
    initialValues: homepageList,
    enableReinitialize: true,
    onSubmit: values => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const [selectedIndex, setSelectedIndex] = useState(-1);

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const handleChangeCBstretched = (event, index) => {
    let items = [...widgets];
    setSelectedIndex(index);
    if (index !== -1) {
      if (Object.keys(items[index]?.data["stretched"] !== undefined)) {
        items[index].data.stretched = event.target.checked;
        setModified(items[index]);
        formik.setFieldValue('widget', JSON.stringify(widgets));
      }
    }
  };

  //Number of LiveSliderLatest
  const handleChangeNumber = (event, index) => {
    setWidgetSettingsOk(true);
    let items = [...widgets];
    setSelectedIndex(index);
    if (index !== -1) {
      if (Object.keys(items[index]?.data["number"]) !== undefined) {
        items[index].data.number = event.target.value;
        setModified(items[index]);
        formik.setFieldValue('widget', JSON.stringify(widgets));
      }
    }
  };

  const [state, setState] = useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    message: '',
    severity: 'success',
    ahduration: 3000,
    instructions: ''
  });

  const { open, vertical, horizontal, message, severity, ahduration, instructions } = state;
  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  //Footer components
  const componentArrayFooter = [
    // <div>Prova testo</div>,
    <div>
      {
        widgetsStateModified ? <>
          <span style={{
            padding: "0px 35px", margin: "0 16px 0 0",
            backgroundColor: "rgb(255, 193, 7)", borderRadius: "6px"
          }}>
          </span>
          <span>
            Nuovo widget, modificato o clonato
          </span>
        </> : ""
      }
    </div>,
    <div>
      <button type="button" className="btn btn-primary" //disabled={widgetsStateModified} 
        onClick={() => { window.open(`${REACT_APP_SI_DOMAIN}/` + uri, '_blank'); }}
        title="Apri su StartupItalia"
        style={{ minWidth: "20%", padding: "0 8px" }}>
        Apri {uri}
      </button>
    </div >
    ,
    /*  <div>
       <button type="button" className="btn btn-primary" //disabled={widgetsStateModified} 
         onClick={() => { save(`${REACT_APP_SI_DOMAIN}/` + uri) }}
         title="Salva e apri su StartupItalia"
         style={{ minWidth: "20%", padding: "0 8px" }}>
         Salva e apri {uri}
       </button>
     </div>, */
    <div>
      <button type="button" className="btn btn-success" //disabled={widgetsStateModified} 
        onClick={() => { save(`${REACT_APP_SI_DOMAIN}/` + uri + '/preview', true) }}
        title="Preview su StartupItalia"
        disabled={!userpermission.PermissionCheck('can_edit_homes', [...authCtx.permissionList])}
        style={{ minWidth: "20%", padding: "0 8px" }}>
        Widgets Preview
      </button>
    </div>
    // <div>Prova testo 2</div>,
  ];

  const fetchData = useCallback(async (uri) => {
    //console.log('homepage uri:', uri);
    setWidgetIndex(-1); setSelectedIndex(-1);
    setWidgetSettingsOk(true);
    setIsLoading(true);
    const hpList = await HomePageService.getList(
      {
        id: '',
        title__icontains: '',
        description__icontains: '',
        uri: uri + '/'
      }
    );

    if (hpList.count === 0) {
      console.error(`No homepage o backend for uri: ${uri}/`);
    }
    setHomepageList(hpList.results[0]);

    var widgetsList = JSON.parse(hpList.results[0].widget).map(function (widget) {
      return widget;
      //return widget === null ? '' : widget;
    })
    //console.log('widgetsList: ', widgetsList);
    setWidgets(widgetsList);
    setIsLoading(false);
  }, [])

  useEffect(() => {
    fetchData(uri);
    //eslint-disable-next-line
  }, [uri, fetchData]);

  useEffect(() => {
    formik.setFieldValue('widget', JSON.stringify(widgets));
    if (formik.values.id) {
      saveWidgetPreview(formik.values.id, JSON.stringify([]));
    }
    //eslint-disable-next-line
  }, [widgets]);

  /* useEffect(() => {
    return console.log(`You changed the page`);
  }, [location.pathname]) */

  //DND
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const newWidgets = Array.from(widgets);
    const [removed] = newWidgets?.splice(result?.source?.index, 1);
    newWidgets?.splice(result?.destination?.index, 0, removed);
    setModified(widgets[result?.source?.index]);
    setWidgets(newWidgets);
  };

  function handleUpdate(_newTagValue, _oldTagValue) {
    setWidgetSettingsOk(false);
    let items = [...widgets];
    if (_newTagValue && Object.keys(_newTagValue).length !== 0) {
      let exist = [];

      items.filter((i, index) => i.data?.tag?.id === _newTagValue.id ? exist.push(index) : null);

      if (exist.length > 0) {
        var msg = exist.map(function (res, index) {
          return <span key={index}>
            • Widget N° {(parseInt(res) + 1)} <br></br>
          </span>
        })

        setState({
          open: true,
          vertical: 'top',
          horizontal: 'center',
          message: 'Il tag selezionato è già presente nella lista!',
          severity: 'warning',
          ahduration: null,
          instructions: msg
        })
        //return;
      }

      if (selectedIndex !== -1) {
        if (items[selectedIndex].data.tag) {
          items[selectedIndex].data.tag = _newTagValue;
          setModified(items[selectedIndex]);
          formik.setFieldValue('widget', JSON.stringify(widgets))
        }
        setWidgetSettingsOk(true);
      }
    }
    else if (selectedIndex !== -1) {
      if (items[selectedIndex].data.tag) {
        items[selectedIndex].data.tag = {};
        formik.setFieldValue('widget', JSON.stringify(widgets))
      }
    }
  }

  function getWidget(widgetIndex) {
    let items = [...widgets];
    let widget = items.filter((i, index) => { return index === widgetIndex });
    return widget;
  }

  function addWidget() {
    setWidgetIndex(null);
    let items = [...widgets];
    if (items.length <= maxWidgets - 1) {
      items.push({
        widget: '',
        data: {}
      });
      setWidgets(items);
    }
  }

  function removeWidget(_index, _warn) {
    let items = [...widgets];
    if (_index !== -1) {
      items.splice(_index, 1);
      setWidgets(items);
      if (_warn) setWidgetsStateModified(true);
    }
  }

  function cloneWidgetType(widget) {
    let items = [...widgets];
    if (items.length <= maxWidgets - 1) {
      items.push({
        widget: widget.widget,
        data: widget.data
      });
      setWidgets(items);
      setModified(items[items.length - 1]);
      setTimeout(() => {
        bottomTableRef?.current?.scrollIntoView({ behavior: "smooth" });
      }, 250);
    }
  }

  function updateWidgetType(e, _index) {
    //setWidgetType(e);
    setWidgetSettingsOk(false);
    setWidgetIndex(_index);
    let items = [...widgets];
    if (_index !== -1) {
      items[_index].widget = e;
      if (e === 'LiveSlider' || e === 'LiveGrid') {
        const emData = { stretched: false, tag: {} };
        items[_index].data = emData;
      }
      if (e === 'LiveSliderLatest') {
        const emData = { stretched: false, number: 0 };
        items[_index].data = emData;
      }
      if (e === 'Countdown') {
        setShowCountdown(true);
      }
      if (e === 'MultipleLinkChips') {
        setShowMultipleLinkChips(true);
      }
      if (e === 'CategoryHeader') {
        setShowCategoryHeader(true);
      }
      if (e === 'VerticalHeader') {
        setShowVerticalHeader(true);
      }
      if (e === 'IndexHeader') {
        setShowIndexHeader(true);
      }
      if (e === 'RubricHeader') {
        setShowRubricHeader(true);
      }
      if (e === 'SingleLive') {
        setShowSingleLive(true);
      }
      if (e === 'SingleHugeArticle') {
        setShowSingleHugeArticle(true);
      }
      if (e === 'SingleBigArticle') {
        setShowSingleBigArticle(true);
      }
      if (e === 'SingleMediumArticle') {
        setShowSingleMediumArticle(true);
      }
      if (e === 'MultipleArticles') {
        setShowMultipleArticles(true);
      }
      if (e === 'MultipleSelectedArticles') {
        setShowMultipleSelectedArticles(true);
      }
      if (e === 'MultipleSelectedArticlesSlider') {
        setShowMultipleSelectedArticlesSlider(true);
      }
      if (e === 'TrendingTopics') {
        setShowTrendingTopics(true);
      }
      if (e === 'TrendingTopicsMultipleSelectedArticles') {
        setShowTrendingTopicsMultipleSelectedArticles(true);
      }
      if (e === 'SocialMediaButtons' || e === 'EventSlider' || e === 'AnnouncementSlider'
        || e === 'Banners' || e === 'SearchLiveBar') {
        items[_index].data = {};
        setModified(items[_index]);
        setWidgetSettingsOk(true);
      }
      if (e === 'CustomPagination') {
        setShowCustomPagination(true);
      }
      if (e === 'CustomEditor') {
        setShowCustomEditor(true);
      }
      if (e === 'MapWidgetRegions') {
        items[_index].data = {};
      }
      if (e === 'AdvBanner') {
        items[_index].data = {};
      }
      setWidgets(items);
    }
  }

  function handleUpdateData(data, index) {
    //console.log('data: ', data, index);
    setWidgetSettingsOk(true);
    let items = [...widgets];

    //reset Show All Widgets
    setShowCountdown(false);
    setShowMultipleLinkChips(false);
    setShowCategoryHeader(false);
    setShowVerticalHeader(false);
    setShowIndexHeader(false);
    setShowRubricHeader(false);
    setShowSingleLive(false);
    setShowSingleHugeArticle(false);
    setShowSingleBigArticle(false);
    setShowSingleMediumArticle(false);
    setShowMultipleArticles(false);
    setShowMultipleSelectedArticles(false);
    setShowMultipleSelectedArticlesSlider(false);
    setShowTrendingTopics(false);
    setShowTrendingTopicsMultipleSelectedArticles(false);
    setShowCustomPagination(false);
    setShowCustomEditor(false);
    setShowPreview(false);

    if (data === null) {
      removeWidget(index, false);
      return;
    }

    if (data !== null && index !== -1) {
      items[index].data = data;
      setModified(items[index]);
    }

    setWidgetIndex(-1);
    setWidgets(items);
  }

  function setModified(item) {
    if (!item.hasOwnProperty('isModified')) {
      Object.assign(item, { isModified: true });
      setWidgetsStateModified(true);
    }
  }

  function resetWidgets() {
    const widgetsList = JSON.parse(homepageList.widget).map((widget, index) => (
      widget
    ));
    setWidgetIndex(-1); setSelectedIndex(-1); setWidgetSettingsOk(true);
    setWidgets(widgetsList);
    setWidgetsStateModified(false);
  }

  async function save(_url, preview = false, copyToClipboard = false) {
    let items = [...widgets];
    if (widgetIndex === null) {
      setState({
        open: true,
        vertical: 'top',
        horizontal: 'center',
        message: 'Seleziona un widget dalla select prima di salvare!',
        severity: 'warning',
        ahduration: 2000,
        instructions: ''
      })
      return;
    }

    let toVerify = [];
    items.forEach((i, index) => {
      if ((i.data && (Object.keys(i.data).length === 0)) === true) {
        if (
          i.widget === 'Countdown' ||
          i.widget === 'MultipleLinkChips' ||
          i.widget === 'CategoryHeader' ||
          i.widget === 'VerticalHeader' ||
          i.widget === 'IndexHeader' ||
          i.widget === 'RubricHeader' ||
          i.widget === 'LiveSlider' ||
          i.widget === 'LiveSliderLatest' ||
          i.widget === 'LiveGrid' ||
          i.widget === 'SingleLive' ||
          i.widget === 'SingleHugeArticle' ||
          i.widget === 'SingleBigArticle' ||
          i.widget === 'SingleMediumArticle' ||
          i.widget === 'MultipleArticles' ||
          i.widget === 'MultipleSelectedArticles' ||
          i.widget === 'MultipleSelectedArticlesSlider' ||
          i.widget === 'CustomPagination' ||
          i.widget === 'CustomEditor' ||
          i.widget === 'MapWidgetRegions' ||
          i.widget === 'AdvBanner'
        ) {
          toVerify.push({ 'error_data_index': index });
        }
      }
      if ((i.data?.tag && (Object.keys(i.data?.tag).length === 0)) === true) {
        toVerify.push({ 'error_tag_index': index })
      }
    });

    if (toVerify.length > 0) {
      var msg = toVerify.map(function (res, index) {
        if (res.error_data_index) {
          return <span key={index}>
            • Widget N° {(parseInt(res.error_data_index) + 1)} non ha i dati necessari!<br></br>
          </span>
        } else if (res.error_tag_index) {
          return <span key={index}>
            • Aggiungi un tag al widget N° {(parseInt(res.error_tag_index) + 1)} <br></br>
          </span>
        } else return <span key={index}></span>;
      })

      setState({
        open: true,
        vertical: 'top',
        horizontal: 'center',
        message: 'Impossibile salvare. Verifica i widgets',
        severity: 'warning',
        ahduration: null,
        instructions: msg
      })
      return;
    }

    let imsg = null;
    let data = formik.values;
    let _id = 0;

    let formData = new FormData();
    Object.keys(data).forEach(fieldName => {
      if (fieldName === 'id') { _id = data[fieldName] }
      if (fieldName !== 'widget') {
        if (fieldName === 'widget_preview') {
          formData.append(fieldName, JSON.stringify([]));
        } else formData.append(fieldName, data[fieldName]);
      } else if (fieldName === 'widget') {
        //Clear widget modified
        if (!preview) {
          items.forEach((item) => {
            delete item['isModified'];
          })
        }
        formData.append('widget', JSON.stringify(items));
      }
    });

    data = formData;

    /* for (var pair of data.entries()) {
      console.log(pair[0] + ', ' + pair[1]);
    } */

    if (copyToClipboard) {
      setText(JSON.stringify(items));
      copyText();
      return;
    }

    if (preview) {
      saveWidgetPreview(_id, JSON.stringify(items));
      setShowPreview(true);
      //window.open(_url, '_blank', 'location=yes,height=1024,width=768,scrollbars=yes,status=yes');
      return;
    }

    try {
      let resObject = await HomePageService.update(_id, data);
      let res = {
        live: resObject.data,
        error_code: resObject.status,
        error_msg: resObject.data
      };
      if (!res || res.error_code !== 200) {
        console.log(`Error setLiveview: `, res.error_msg);
        //imsg = JSON.stringify(res.error_msg);
        setErrors([{ slug: res.error_msg.detail }]);
        setState({
          open: true,
          vertical: 'top',
          horizontal: 'center',
          message: 'Errore, non è stato possibile salvare!',
          severity: 'error',
          ahduration: null,
          instructions: imsg
        });
        return {
          revalidate: 5,
          notFound: true,
        }
      }
      setState({
        open: true,
        vertical: 'top',
        horizontal: 'center',
        message: 'Salvata correttamente!',
        severity: 'success',
        ahduration: 2000,
        instructions: null
      })
      console.log(`Result of PUT:`, res.live);
      setWidgetSettingsOk(true);
      setWidgetsStateModified(false);
      setErrors([]);
      fetchData(uri);
      if (_url && !preview) window.open(_url, '_blank');
    } catch (e) {
      console.log(e);
      return {
        revalidate: 5,
        notFound: true,
      }
    }
  }

  async function saveWidgetPreview(_id, data) {
    try {
      let resObject = await HomePageService.updateWidgetPreview(_id, data);
      if (resObject.status === 403)
        setErrors([{ slug: 'ATTENZIONE! Non hai i permessi necessari per salvare le modifiche, utilizza copy list widgets' }]);
    }
    catch (error) {
      console.error(error.response.data);
      return {
        revalidate: 5,
        notFound: true,
      }
    }
  }

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  return (
    <>
      <TitleGrows txtTitle={'Homepage ' + uri} />
      <div style={{ textAlign: "center", padding: "6px", fontSize: "1.25rem", fontWeight: "bold" }}><HintError errors={errors} ></HintError></div>
      {isLoading ? <Loading /> :
        <>
          <div className="card mybox w-100">
            <div className="card-body">
              <div className="card-title">
                <div className="row" style={{ justifyContent: "center" }}>
                  <div className="col-12">
                    <span className="fw-bold">Uri:</span>

                    <input type="text" id="uri" className="form-control" disabled style={{ width: "100%", border: errors?.uri ? "2px solid red" : '' }}
                      onChange={formik.handleChange}
                      value={formik.values.uri}
                    />
                  </div>
                </div>
              </div>
              <div className="card-title">
                <div className="row" style={{ justifyContent: "center" }}>
                  <div className="col-12">
                    <span className="fw-bold">
                      <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                      &nbsp;Title: <HintError errors={errors?.title} ></HintError></span>

                    <input type="text" id="title" className="form-control" style={{ width: "100%", border: errors?.title ? "2px solid red" : '' }}
                      onChange={formik.handleChange}
                      value={formik.values.title}
                    />
                  </div>
                </div>
              </div>
              <div className="card-title">
                <div className="row" style={{ justifyContent: "center" }}>
                  <div className="col-12">
                    <span className="fw-bold">
                      Description: <HintError errors={errors?.description} ></HintError></span>

                    <input type="text" id="description" className="form-control" style={{ width: "100%", border: errors?.description ? "2px solid red" : '' }}
                      onChange={formik.handleChange}
                      value={formik.values.description}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="card-title">
                  <div className="row" style={{ marginTop: "10px", marginBottom: "10px", }}>
                    <div className="col-12">
                      <button type="button" className="btn btn-sm btn-primary active"
                        style={{ maxWidth: "120px", float: "right" }} onClick={() => resetWidgets()}
                        title="Ricarica i widgets salvati">Reset widgets</button>
                      <button type="button" className="btn btn-sm btn-light"
                        style={{ minWidth: "180px", float: "left" }}
                        onClick={() => { save('', false, true) }}
                        title="Copia la lista dei widgets negli appunti">
                        {copied ? <span style={{ verticalAlign: "text-bottom", padding: "6px" }}>List copied</span>
                          : <span style={{ verticalAlign: "text-bottom", padding: "6px" }}>Copy list widgets</span>}
                        <FontAwesomeIcon
                          sx={{ padding: "2px" }}
                          icon={['fas', 'clipboard']}
                          title=""
                          size={'2x'}
                          color={'#6c757d'}
                        />
                      </button>
                    </div>
                  </div>
                  <div className="row user-select-none">
                    <div className="col-12">
                      {(widgets.length > 0) &&
                        (
                          <>
                            {widgetsStateModified ? <span className="fw-bold user-select-none px-1"
                              style={{ backgroundColor: "rgb(255, 193, 7)", borderRadius: "6px" }}
                            >Widgets*:</span>
                              : <span className="fw-bold user-select-none px-1">Widgets:</span>}
                            <DragDropContext onDragEnd={onDragEnd} >
                              <Droppable droppableId="droppable_hp" >
                                {(provided) => (
                                  <div {...provided.droppableProps} ref={provided.innerRef}>
                                    {widgets.map((widget, index) =>
                                    (
                                      <Draggable key={index} draggableId={index.toString()} index={index}
                                        isDragDisabled={!widgetSettingsOk}>
                                        {(provided, snapshot) => (
                                          <div {...provided.placeholder}>

                                            <DragItem className="row d-flex align-items-center p-0"
                                              ref={provided.innerRef}
                                              snapshot={snapshot}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}

                                            >

                                              <div className="col-1 text-md-center" style={{ maxWidth: "76px" }}>
                                                <span style={{ margin: "0 16px 0 0" }}>
                                                  <FontAwesomeIcon icon={['fas', 'grip-vertical']} size={'1x'} color={'#198754'}
                                                    title="Drag and drop" />
                                                </span>
                                                <span className="fw-bold" >{index + 1}</span>
                                              </div>
                                              <div className="col-2 p-0 position-relative">
                                                {widget?.isModified && <span className="position-absolute top-0 start-0 translate-middle p-1 
                                                bg-warning border border-light rounded-circle">
                                                </span>}
                                                <span style={{ fontSize: widget?.widget.length > 20 ? "14px" : '' }}>
                                                  {widget.widget}
                                                </span>
                                              </div>
                                              {(() => {
                                                switch (widget.widget) {
                                                  case 'LiveSlider':
                                                  case 'LiveGrid':
                                                    return <>
                                                      <div className="col-2 p-0">
                                                        <FormGroup aria-label="stretched" row>
                                                          <FormControlLabel
                                                            sx={{ margin: "0px 12px" }}
                                                            value="start"
                                                            control={
                                                              <Checkbox
                                                                checked={widget.data?.stretched}
                                                                onChange={(event) => handleChangeCBstretched(event, index)}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                              />
                                                            }
                                                            label="Stretched"
                                                            labelPlacement="start" />
                                                        </FormGroup>
                                                      </div>
                                                      <div className="col-5 p-0">
                                                        <ListItemButton className='rounded p-2'
                                                          selected={selectedIndex === index}
                                                          onClick={(event) => handleListItemClick(event, index)}
                                                        >
                                                          <LivetagAutocomplete tags={[widget.data?.tag]} isMultiple={false}
                                                            newLabel='Search Tag' shrink={true} onUpdate={handleUpdate} noClearable={true}>
                                                          </LivetagAutocomplete>
                                                        </ListItemButton>
                                                      </div>
                                                    </>
                                                  case 'LiveSliderLatest':
                                                    return <>
                                                      <div className="col-2 p-0">
                                                        <FormGroup aria-label="stretched" row>
                                                          <FormControlLabel
                                                            sx={{ margin: "0px 12px" }}
                                                            value="start"
                                                            control={
                                                              <Checkbox
                                                                checked={widget.data?.stretched}
                                                                onChange={(event) => handleChangeCBstretched(event, index)}
                                                                inputProps={{ 'aria-label': 'controlled' }}
                                                              />
                                                            }
                                                            label="Stretched"
                                                            labelPlacement="start" />
                                                        </FormGroup>
                                                      </div>
                                                      <div className="col-5 p-2">
                                                        <TextField
                                                          id="outlined-number"
                                                          label="Lives/Videos"
                                                          type="number"
                                                          defaultValue={widget.data?.number}
                                                          onChange={(event) => handleChangeNumber(event, index)}
                                                          InputLabelProps={{
                                                            //shrink riduce la label in alto
                                                            shrink: true,
                                                          }}
                                                          inputProps={{
                                                            inputMode: 'numeric', pattern: '[0-9]*',
                                                            style: { width: "100%", minWidth: "72px", height: "5px" }, min: 1, max: 100
                                                          }}
                                                        />
                                                      </div>
                                                    </>

                                                  case 'Countdown':
                                                  case 'MultipleLinkChips':
                                                  case 'CategoryHeader':
                                                  case 'VerticalHeader':
                                                  case 'IndexHeader':
                                                  case 'RubricHeader':
                                                  case 'SingleLive':
                                                  case 'SingleHugeArticle':
                                                  case 'SingleBigArticle':
                                                  case 'SingleMediumArticle':
                                                  case 'MultipleArticles':
                                                  case 'MultipleSelectedArticles':
                                                  case 'MultipleSelectedArticlesSlider':
                                                  case 'TrendingTopics':
                                                  case 'TrendingTopicsMultipleSelectedArticles':
                                                  case 'SocialMediaButtons':
                                                  case 'EventSlider':
                                                  case 'AnnouncementSlider':
                                                  case 'Banners':
                                                  case 'SearchLiveBar':
                                                  case 'CustomPagination':
                                                  case 'CustomEditor':
                                                    return <WidgetDataRow widget={widget}></WidgetDataRow>
                                                  case 'MapWidgetRegions':
                                                    return <>
                                                      <div className="col-7 p-2">
                                                        <SelectMapList index={index} widget={widget} onUpdate={handleUpdateData} />
                                                      </div>
                                                    </>
                                                  case 'AdvBanner':
                                                    return <>
                                                      <div className="col-7 p-2">
                                                        <SelectAdvBannerList index={index} widget={widget} onUpdate={handleUpdateData} />
                                                      </div>
                                                    </>
                                                  default:
                                                    return <>
                                                      <div className="col-7 p-0">
                                                        <FormControl required sx={{ mx: 1, minWidth: 140 }}>
                                                          <InputLabel id="widget-select-required-label">Widget</InputLabel>
                                                          <Select
                                                            labelId="widget-select-required-label"
                                                            id="widget-select-required"
                                                            value={widgetType}
                                                            label="Widget "
                                                            onChange={(selectedValue) => updateWidgetType(selectedValue.target.value, index)}
                                                          >
                                                            <MenuItem value="">
                                                              <em>None</em>
                                                            </MenuItem>
                                                            {
                                                              arrWidgetType?.map((e, index) => ([
                                                                <ListSubheader key={index} className={classesS.listSubheaderGroup}>{e.groupName}</ListSubheader>,
                                                                e.widgetsNames?.map((wn, i) => ([
                                                                  <MenuItem key={i} value={wn}>{wn}</MenuItem>
                                                                ]))
                                                              ]))
                                                            }
                                                          </Select>
                                                          {/* <FormHelperText>Required</FormHelperText> */}
                                                        </FormControl>
                                                        <div className="col-3"></div>
                                                      </div>
                                                    </>
                                                }
                                              }
                                              )()}
                                              <div className="col-1 text-md-center" style={{ padding: "0px" }}>
                                                {widgetSettingsOk === false ?
                                                  widgets.length - 1 === index &&
                                                  <IconButton
                                                    onClick={() => { removeWidget(index, false); setWidgetIndex(-1); setSelectedIndex(-1); setWidgetSettingsOk(true); }}
                                                    edge="end" aria-label="delete"
                                                    style={{ margin: "2px" }}
                                                  >
                                                    <FontAwesomeIcon icon={['fas', 'minus']} title="Elimina" size={'1x'} color={'red'} />
                                                  </IconButton>
                                                  :
                                                  <div>
                                                    <IconButton
                                                      onClick={() => { removeWidget(index, true); setWidgetIndex(-1); setSelectedIndex(-1); setWidgetSettingsOk(true); }}
                                                      edge="end" aria-label="delete"
                                                      style={{ margin: "2px" }}
                                                    >
                                                      <FontAwesomeIcon icon={['fas', 'minus']} title="Elimina" size={'1x'} color={'red'} />
                                                    </IconButton>
                                                  </div>}
                                              </div>
                                              <div className="col-1 text-md-center" style={{ padding: "0px" }}>
                                                {widget?.widget !== 'LiveSlider' && widget?.widget !== 'LiveSliderLatest' && widget?.widget !== 'LiveGrid' &&
                                                  widget?.widget !== 'SocialMediaButtons' && widget?.widget !== 'EventSlider' &&
                                                  widget?.widget !== 'AnnouncementSlider' && widget?.widget !== 'Banners' &&
                                                  widget?.widget !== 'SearchLiveBar' && widget?.widget !== 'MapWidgetRegions' &&
                                                  widgetSettingsOk === true &&
                                                  <>
                                                    <IconButton
                                                      onClick={() => { updateWidgetType(widget?.widget, index) }}
                                                      edge="start" aria-label="update"
                                                    //style={{ float: "left", margin: "2px" }}
                                                    >
                                                      <FontAwesomeIcon icon={['fas', 'edit']} title="Modifica" size={'1x'} color={'#198754'} />
                                                    </IconButton>
                                                    <IconButton
                                                      onClick={(e) => { cloneWidgetType(widget) }}
                                                      edge="end" aria-label="clone"
                                                    >
                                                      <FontAwesomeIcon icon={['fas', 'clone']} title="Clona" size={'1x'} color={'#6c757d'} />
                                                    </IconButton>
                                                  </>
                                                }

                                              </div>
                                            </DragItem>
                                          </div>
                                        )}
                                      </Draggable>
                                    ))}
                                  </div>
                                )}
                              </Droppable>
                            </DragDropContext>
                            {showCountdown && <Countdown onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></Countdown>}
                            {showMultipleLinkChips && <MultipleLinkChips onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></MultipleLinkChips>}
                            {showCategoryHeader && <CategoryHeader onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></CategoryHeader>}
                            {showVerticalHeader && <VerticalHeader onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></VerticalHeader>}
                            {showIndexHeader && <IndexHeader onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></IndexHeader>}
                            {showRubricHeader && <RubricHeader onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></RubricHeader>}
                            {showSingleLive && <SingleLive onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></SingleLive>}
                            {showSingleHugeArticle && <SingleArticle onUpdate={handleUpdateData} info={{ title: "Single Huge Article" }}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _kind={'post'} _all_origin_domain={allOriginDomain} ></SingleArticle>}
                            {showSingleBigArticle && <SingleArticle onUpdate={handleUpdateData} info={{ title: "Single Big Article" }}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _kind={'post'} _all_origin_domain={allOriginDomain} ></SingleArticle>}
                            {showSingleMediumArticle && <SingleArticle onUpdate={handleUpdateData} info={{ title: "Single Medium Article" }}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _kind={'post'} _all_origin_domain={allOriginDomain} ></SingleArticle>}
                            {showMultipleArticles && <MultiArticlesFilter isMultipleArticles={true} onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _all_origin_domain={allOriginDomain}></MultiArticlesFilter>}
                            {showMultipleSelectedArticles && <MultipleSelectedArticles onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _kind={'post'} info={{ title: "Multiple Selected Articles" }} _all_origin_domain={allOriginDomain}></MultipleSelectedArticles>}
                            {showMultipleSelectedArticlesSlider && <MultipleSelectedArticles onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _kind={'post'} info={{ title: "Multiple Selected Articles Slider" }} _all_origin_domain={allOriginDomain}></MultipleSelectedArticles>}
                            {showTrendingTopics && <MultiArticlesFilter isTrendingTopics={true} onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _all_origin_domain={allOriginDomain}></MultiArticlesFilter>}
                            {showTrendingTopicsMultipleSelectedArticles && <MultiArticlesSelectedManually onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} _all_origin_domain={allOriginDomain}></MultiArticlesSelectedManually>}
                            {showCustomPagination && <CustomPagination onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></CustomPagination>}
                            {showCustomEditor && <CustomEditor onUpdate={handleUpdateData}
                              index={widgetIndex} widget={getWidget(widgetIndex)} ></CustomEditor>}
                            {showPreview && <ShowPreview src={`${REACT_APP_SI_DOMAIN}/` + uri + '/preview'} uri={uri} onUpdate={handleUpdateData}></ShowPreview>}
                          </>
                        )}

                      <div className="row" style={{ textAlign: "right" }}>
                        <div className="col-12" ref={bottomTableRef} style={{ paddingRight: "26px" }}>
                          <>
                            {
                              (widgets.length < maxWidgets
                                && widgetIndex !== null && widgetSettingsOk === true)
                              && <IconButton onClick={() => { addWidget(); setWidgetSettingsOk(false) }} edge="end" aria-label="add">
                                <FontAwesomeIcon
                                  icon={['fas', 'plus']}
                                  title="Aggiungi un widget"
                                  size={'1x'}
                                  color={'#198754'}
                                />
                              </IconButton>
                            }

                          </>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div style={{ margin: "6px 24px 10px 24px" }}>
                <div className="d-grid gap-2 d-md-block">
                  <div className="row">
                    <div className="col-12">
                      <button type="button" onClick={() => { save(); }} className="btn btn-primary" style={{ width: "6rem", float: "right" }}>Salva</button>
                      <span style={{ color: "red", float: "right", margin: "16px 10px 0px 0px" }}>
                        <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                        <span className="user-select-none">Indica un campo obbligatorio</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div style={{ height: "20px" }}></div>
          <FooterFixedBottom uri={uri} componentArray={componentArrayFooter}></FooterFixedBottom>

          <Snackbar open={open} autoHideDuration={ahduration} onClose={handleClose}
            anchorOrigin={{ vertical, horizontal }} >
            <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
              <div style={{ textAlign: "center" }}>{message}</div>
              {instructions ?
                <div style={{ margin: "10px 0 0 0" }}>
                  {instructions}
                </div>
                : ''}
            </Alert>
          </Snackbar>
        </>
      }
    </>
  );
}
